<template>
  <div class="pt-3">
    <v-form @submit.prevent="searchUp">
      <v-col class="d-flex">
        <v-text-field
          v-model="searchKey"
          hide-details="auto"
          label="Search"
          outlined
          autofocus
          dense
          clearable
        />
        <v-btn
          :disabled="!searchKey"
          class="info ml-2"
          type="submit"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-form>
    <v-col>
      <template v-if="show">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Purchased at
                </th>
                <th class="text-left">
                  TRX
                </th>
                <th class="text-left">
                  Customer
                </th>
                <th class="text-left">
                  Phone
                </th>
                <th class="text-left">
                  IMIE
                </th>
                <th class="text-left">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="searched.length > 0">
                <tr
                  v-for="item in searched"
                  :key="item.id"
                >
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.key }}</td>
                  <td>{{ item.fullName }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.imie }}</td>
                  <td>
                    <template v-if="item.isSold">
                      Sold
                    </template>
                    <template v-else>
                      Not Sold
                    </template>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td
                    colspan="6"
                    class="error--text"
                  >
                    Not found
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </template>
      <template v-else>
        <strong>Tip :</strong>
        <p>
          Search custom product (purchased form customer) with following keys
        </p>
        <ul>
          <li>TRX key</li>
          <li>By Customer Name</li>
          <li>By Customer Phone</li>
          <li>By IMIE</li>
          <li>By Model</li>
        </ul>
      </template>
    </v-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      searchKey: "",
      searched: [],
    };
  },
  watch: {
    searchKey() {
      if (this.searchKey === "" || this.searchKey === null) {
        this.$data.searched = [];
        this.$data.show = false;
      }
    },
  },
  methods: {
    searchUp() {
      window.axios
        .post("/custom-product-search", { key: this.searchKey })
        .then((response) => {
          this.$data.show = true;
          this.$data.searched = response.data.items;
        });
    },
  },
};
</script>
